import storage from 'redux-persist/lib/storage'

const configurePersist = {
    key: 'root',
    storage: storage,
    whitelist: ['themeReducer', 'languageReducer', 'tokenReducer']
}

export default configurePersist